import React, { useEffect, useRef, useState } from "react";
import Footer from "../../components/nav-bar/Footer";
import "react-phone-number-input/style.css";
import "../../style/ContactUs.css";
import PhoneInputWithCountry from "react-phone-number-input";
import { CircularProgress } from "@mui/material";
import { useToast } from "../../ToastContext";
import { handleContactUs } from "../../api/contact";
import ReCAPTCHA from "react-google-recaptcha";

function ContactUs() {
  const toast = useToast();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
    website: "", // honeypot — leave empty
  });
  const [captchaToken, setCaptchaToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const dashboardRef = useRef(null);
  const captchaRef = useRef(null);
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    if (dashboardRef.current) {
      dashboardRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!formData.phone || !formData.phone.startsWith("+")) {
      toast.error("Please enter a valid phone number in E.164 format.");
      setLoading(false);
      return;
    }

    if (siteKey && !captchaToken) {
      toast.error("Please complete the captcha.");
      setLoading(false);
      return;
    }

    try {
      const response = await handleContactUs({
        ...formData,
        captchaToken,
      });
      if (response && response.data && response.status === 200) {
        setFormData({
          name: "",
          email: "",
          subject: "",
          phone: "",
          message: "",
          website: "",
        });
        setCaptchaToken(null);
        captchaRef.current?.reset?.();
        toast.success("Form submitted successfully!");
      }
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        "Error submitting form. Please try again.";
      toast.error(msg);
      captchaRef.current?.reset?.();
      setCaptchaToken(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contactUs-page" ref={dashboardRef}>
      <div className="contactUs-container-page">
        <div className="contactUs-first-pages">
          <div className="contactUs-heading">
            <span className="contactus-first-heading">Contact Us</span>
            <p className="para-contactus-head">
              Please fill out the form below to get in touch with us.
            </p>
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            {/* Honeypot for bots — hidden from real users */}
            <div
              aria-hidden="true"
              style={{
                position: "absolute",
                left: "-10000px",
                top: "auto",
                width: "1px",
                height: "1px",
                overflow: "hidden",
              }}
            >
              <label htmlFor="website">Website</label>
              <input
                type="text"
                id="website"
                name="website"
                tabIndex={-1}
                autoComplete="off"
                value={formData.website}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
                maxLength={100}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Enter the subject"
                required
                maxLength={200}
              />
            </div>
            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <PhoneInputWithCountry
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={(value) => setFormData({ ...formData, phone: value })}
                placeholder="Enter your phone number"
                country="US"
                international
                defaultCountry="US"
                required
                className="phone-input"
              />
            </div>
            <div className="form-group message-textarea-align">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Type your message here."
                required
                maxLength={5000}
              ></textarea>
            </div>
            {siteKey ? (
              <div className="form-group captcha-group">
                <label htmlFor="contact-us-recaptcha">Verification</label>
                <ReCAPTCHA
                  id="contact-us-recaptcha"
                  ref={captchaRef}
                  sitekey={siteKey}
                  onChange={(token) => setCaptchaToken(token)}
                  onExpired={() => setCaptchaToken(null)}
                />
              </div>
            ) : null}
            <div className="button-group">
              <button
                type="submit"
                className="submit-button-contactUS"
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Send"
                )}
              </button>
            </div>
          </form>
        </div>
        <div style={{ marginTop: "50px" }}>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
